import { render, staticRenderFns } from "./ListOrdens.vue?vue&type=template&id=76a0e77d&scoped=true&"
import script from "./ListOrdens.vue?vue&type=script&lang=js&"
export * from "./ListOrdens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0e77d",
  null
  
)

export default component.exports